module.exports = __webpack_public_path__ + "static/media/ziyuanguanlixitong.4d8efc83.png";